import {RatingBreakup} from '@stencil/hotels-types/src/details-cg/types';
import {isObjectEmpty, memoizeFunction} from '../common-utils';

export const calculateRatingBreakup = (ratingBreakup: RatingBreakup) => {
  if (!ratingBreakup || isObjectEmpty(ratingBreakup)) return [];
  const totalSum = Object.values(ratingBreakup).reduce((sum, value) => sum + value, 0);
  let ratingBreakupWithCount = Object.entries(ratingBreakup).map(([key, count]) => ({
    name: key,
    count,
    rating: (count / totalSum) * 100,
  }));
  ratingBreakupWithCount = ratingBreakupWithCount?.reverse();
  return ratingBreakupWithCount;
};

export const ratingBreakupCalculator = memoizeFunction(calculateRatingBreakup);
